import { render, staticRenderFns } from "./Innovate.vue?vue&type=template&id=1549f764&scoped=true&"
import script from "./Innovate.vue?vue&type=script&lang=js&"
export * from "./Innovate.vue?vue&type=script&lang=js&"
import style0 from "./Innovate.vue?vue&type=style&index=0&id=1549f764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1549f764",
  null
  
)

export default component.exports